import React from "react";
import { Box, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Footer from "../../globalCountries/countryhomepagescomponent/Footer";
import globalStyles from "../../../global";
import News from "../../globalCountries/countryhomepagescomponent/News";
import FreeDeliveryBanner from "../countryhomepagescomponent/FreeDeliveryBanner";

const TermsAndConditions = () => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;

  const terms = t("termsAndConditions.terms", { returnObjects: true }) || [];

  const renderSection = (term, index) => {
    return (
      <li key={index}>
        <Typography sx={styles.text1}>
          {/* Adding section numbering similar to privacy policy */}
          {term}
        </Typography>
      </li>
    );
  };

  const styles = {
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    },
    text1: {
      fontFamily: "'Poppins'",
      fontWeight: 400,
      fontSize: { sm: "20px", xs: "16px" },
      lineHeight: { sm: "30px", xs: "24px" },
      letterSpacing: "0%",
      textAlign: "justify",
      color: "#4d4d4d",
      // textAlign: isRTL ? "right" : "left",
    },
    mainText: {
      fontFamily: globalStyles.fonts.primary,
      fontWeight: 400,
      fontSize: { sm: "20px", xs: "16px" },
      lineHeight: "30px",
      letterSpacing: "0%",
      textAlign: "justify",
      color: "#4d4d4d",
      width: "100%",
      maxWidth: "1200px",
      mx: "auto",
      mt: 8,
      py: 4,
      px: {
        xs: 1,
        sm: 0,
      },
      direction: isRTL ? "rtl" : "ltr",
    },
    // heroContainer: {
    //   position: "relative",
    //   height: {
    //     xs: "280px",   // mobile
    //     sm: "440px",   // tablets
    //     md: "500px",   // laptops/desktops
    //   },
    //   display: "flex",
    //   alignItems: "center",
    //   justifyContent: "center",
    //   "&::before": {
    //     content: '""',
    //     position: "absolute",
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     bottom: 0,
    //     backgroundImage: `url(${imageBaseUrl}termsandconditions_banner.svg)`,
    //     backgroundSize: "cover",
    //     backgroundPosition: "center",
    //     transform: isRTL ? "scaleX(-1)" : "scaleX(1)",
    //     zIndex: 0,
    //   },
    // },
    heroTextContainer: {
      position: "absolute",
      inset: 0,
      display: "flex",
      alignItems: { xs: "center", sm: "center" }, // Center vertically on all screens
      justifyContent: { xs: "center", sm: isRTL ? "flex-start" : "flex-end" }, // Center horizontally on mobile
      width: { sm: "60%" },
      marginLeft: isRTL ? 0 : "auto",
      marginRight: isRTL ? "auto" : 0,
      zIndex: 1,
      py: 6,
      px: 2,
      textAlign: "center", // Center text on mobile
    },
        heroContainer: {
      position: "relative",
      height: {
        xs: "280px",   // mobile
        sm: "440px",   // tablets
        md: "500px",   // laptops/desktops
      },
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: {
        xs: "#e0e7d8", // Mobile: solid color
        sm: "transparent", // Tablet and up: transparent (show image)
      },
      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: {
          xs: "none", // No image on mobile
          sm: `url(${imageBaseUrl}termsandconditions_banner.svg)`, // Image on tablet and up
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        transform: isRTL ? "scaleX(-1)" : "scaleX(1)",
        zIndex: 0,
      },
    },
    heroText: {
      color: globalStyles.colors.army_green,
      fontWeight: 700,
      fontFamily: globalStyles.fonts.primary,
      fontSize: {
        md: "55px",
        sm: "36px",
        xs: "30px",
      },
      textAlign: isRTL ? "right" : "left",
      width: "100%",
      paddingLeft: isRTL ? 0 : { xs: 2, sm: 4, md: 6 },
      paddingRight: isRTL ? { xs: 2, sm: 4, md: 6 } : 0,
    },
    termItem: {
      mb: 4, // Added consistent margin bottom
      "&:last-child": {
        mb: 0,
      },
    },
  };

  return (
    <Box sx={styles.root}>
      <Box sx={styles.heroContainer}>
        <Box sx={styles.heroTextContainer}>
          <Typography variant="h1" sx={styles.heroText}>
            {t("termsAndConditions.pageTitle")}
          </Typography>
        </Box>
      </Box>

      <Container>
        <Box sx={styles.mainText}>
          {Array.isArray(terms) ? (
            <ol type="1" className="list-decimal sm:pl-8 pl-4 m-0">
              {terms.map((term, index) => renderSection(term, index))}
            </ol>
          ) : (
            <Typography sx={styles.text1}>
              {t("termsAndConditions.terms")}
            </Typography>
          )}
        </Box>
      </Container>
      <FreeDeliveryBanner />
      <News />
      <Box sx={{ height: { sm: "80px", xs: "20px" } }} />
      <Footer />
    </Box>
  );
};

export default TermsAndConditions;
